import { render } from "./StoryEnd.vue?vue&type=template&id=1f93c356&scoped=true"
import script from "./StoryEnd.vue?vue&type=script&lang=js"
export * from "./StoryEnd.vue?vue&type=script&lang=js"

import "./StoryEnd.vue?vue&type=style&index=0&id=1f93c356&scoped=true&lang=css"

import exportComponent from "C:\\0_PROJECTS\\EcoSim\\Csongrad\\sar_es_tuz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f93c356"]])

export default __exports__